import { render, staticRenderFns } from "./ComplianceRatioInsurerDept.vue?vue&type=template&id=1c6694f0"
import script from "./ComplianceRatioInsurerDept.vue?vue&type=script&lang=js"
export * from "./ComplianceRatioInsurerDept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports